// extracted by mini-css-extract-plugin
module.exports = {"row":"Amenities--row","column50":"Amenities--column50"};